<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="1360px"
    content-class="max-height-xl"
  >
    <v-card>
      <v-card-subtitle class="text-right px-2 pt-2 pb-0">
        <v-btn icon x-small @click="closeMe" id="document_dialog__cerrar_ventana__button">
          <v-icon>{{ icon.close }}</v-icon>
        </v-btn>
      </v-card-subtitle>

      <v-card-text>
        <v-row>
          <v-col cols="4" class="py-0 border-r">
            <document-detail
              unnotification
              :document="document"
              :readonly="readonly"
            ></document-detail>
          </v-col>
          <v-col cols="8" class="py-0">
            <v-tabs v-model="tab" color="cyan lighten-1">
              <v-tab key="documents" id="document_dialog__documento__tab">DOCUMENTO</v-tab>
              <v-tab key="signers" id="document_dialog__firmantes__tab">FIRMANTES</v-tab>
              <v-tab key="reminders" id="document_dialog__recordatorios__tab">RECORDATORIOS</v-tab>
            </v-tabs>
            <v-tabs-items v-model="tab">
              <v-tab-item key="documents">
                <viewer-p-d-f :class="class_tab" />
              </v-tab-item>
              <v-tab-item key="signers">
                <signers-document 
                  :class="class_tab" 
                  v-model="signersList" 
                  :document="document"
                  :readonly="readonly || document.estatus.descripcion == 'Expirado'" 
                />
              </v-tab-item>
              <v-tab-item key="reminders">
                <p class="font-weight-bold text-subtitle-1">
                  Recordatorios:
                </p>
                <p class="text-body-1">
                  <span v-if="document.estatus.descripcion == 'En proceso' || document.estatus.descripcion == 'Pendiente'">
                    {{ messageNotification }}
                  </span>
                  <span v-if="document.estatus.descripcion == 'Firmado' || document.estatus.descripcion == 'Cancelado' || document.estatus.descripcion == 'Expirado'">
                    {{messageNotificationCancelledSigned}}
                  </span>
                </p>
              </v-tab-item>
            </v-tabs-items>
          </v-col>
        </v-row>
      </v-card-text>
      <notification-container
        :showOnlyLocalNotifications="true"
      ></notification-container>
    </v-card>
  </v-dialog>
</template>

<script>
import { mdiClose } from '@mdi/js'
import DocumentDetail from './DocumentDetail'
import ViewerPDF from '@/modules/signers/components/ViewerPDF'
import SignersDocument from '@/modules/signers/components/SignersDocument'
import NotificationSettings from '@/modules/documents/components/NotificationSettings'

import {
  viewerPDFData,
  viewerPDFActions
} from '@/modules/signers/store/viewerPDFStoreHelpers'

import {
  notificationData,
  notificationActions
} from '@/modules/documents/store/notificationStoreHelpers'

export default {
  name: 'DocumentDialog',
  components: {
    DocumentDetail,
    ViewerPDF,
    SignersDocument,
    NotificationSettings,
  },
  props: {
    value: {
      type: Object
    },
    show: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      icon: {
        close: mdiClose
      },
      tab: null,
      dialog: false,
      checkNotification: true
    }
  },
  created() {
    this.dialog = this.show
    this.loadPeriodicities()
  },
  computed: {
    ...viewerPDFData,
    ...notificationData,
    class_tab(){
      return 'component-tab-' + (this.$vuetify.breakpoint.height <= 720 ? 'md' : 'lg')
    },
    document: {
      get() {
        return Object.assign({}, this.value)
      },
      set(value) {
        this.$emit('input', value)
      }
    },
    signersList: {
      get() {
        return Object.assign([], this.document.firmantes)
      },
      set(value) {
        let updateDocument = Object.assign({}, this.document)
        updateDocument.firmantes = value
        this.document = updateDocument
      }
    }
  },
  methods: {
    ...viewerPDFActions,
    ...notificationActions,
    loadPeriodicities() {
      this.getPeriodicities()
    },
    closeMe() {
      this.dialog = false
      this.$emit('close')
      this.cleanObjectPDF()
    }
  },
  watch: {
    dialog: function(value) {
      if (value) {
        this.downloadDocumentPdf(this.document.idDocumento)
        this.tab = 'documents'
      }
    }
  }
}
</script>

<style>
.component-tab-md {
  height: 480px;
}
.component-tab-lg {
  height: 580px;
}
.border-r {
  border-right: solid;
  border-width: 1px;
  color: lightgrey;
}
.max-height-xl {
  max-height: 98%!important;
}
</style>
